import { Size, useWindowSize } from 'hooks/useWindowSize'
import { FC, useEffect, useState } from 'react'
import './styles.scss'
import { OverlayTrigger, Popover } from 'react-bootstrap'

interface TextToolTipProp {
  text: string
}

const getToolTip = (toolTipText: string): JSX.Element => {
  return (
    <Popover id='popover-text-summary'>
      <Popover.Content>
        <span>{toolTipText}</span>
      </Popover.Content>
    </Popover>
  )
}

const TextTooltip: FC<TextToolTipProp> = ({ text }) => {
  const size: Size = useWindowSize()
  const [isMobileView, setIsMobileView] = useState(false)
  const [isToolTip, setToolTip] = useState(false)

  useEffect(() => {
    const txtDescriptionElements =
      document.getElementsByClassName('text-summary')
    const allDescriptionsList = Array.prototype.slice.call(
      txtDescriptionElements
    )

    // Check the height of the container against the height of  the actual text
    // apply tooltip true if there's a height mismatch
    allDescriptionsList.map((element) => {
      if (element.innerHTML === text) {
        const { offsetHeight, scrollHeight } = element
        if (offsetHeight !== scrollHeight) {
          setToolTip(true)
        }
        return
      }
    })

    if (size.width && size.width > 767) {
      setIsMobileView(false)
    } else {
      setIsMobileView(true)
    }
  }, [size])

  return (
    <>
      {' '}
      {(() => {
        if (isMobileView) {
          return <div className='text-summary-mobile'>{text}</div>
        } else if (isToolTip) {
          return (
            <OverlayTrigger placement='bottom' overlay={getToolTip(text)}>
              {<div className='text-summary'>{text}</div>}
            </OverlayTrigger>
          )
        } else {
          return <div className='text-summary'>{text}</div>
        }
      })()}
    </>
  )
}

export default TextTooltip
